import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarFeature } from 'src/app/public/car/models/car-feature.model';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { CarVersion } from 'src/app/public/car/models/car-version.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';


@Component({
    selector: 'app-carref-versions',
    templateUrl: './carref-versions.component.html',
    styleUrl: './carref-versions.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefVersionsComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() makes: CarMake[] = [];
  @Input() models: CarModel[] = [];
  @Input() versions: CarVersion[] = [];
  @Input() engines: CarEngine[] = [];
  @Input() features: CarFeature[] = [];

  newItem: CarVersion = new CarVersion('', '');
  editedItem: CarVersion = new CarVersion('', '');

  displayedColumns: string[] = ['id', 'makeName', 'modelName', 'name', 'engineNames','featureNames', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarVersion>(this.versions);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.versionsFetchSubmit({}));
    this.store.dispatch (CarRefActions.featuresFetchSubmit({}));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }

  ngOnChanges(changes: SimpleChanges){

    if(changes['versions']){
      this.dataSource.data = changes['versions'].currentValue;
    }

    if(changes['features']){
      this.dataSource.data = changes['features'].currentValue;
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarVersion('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarVersion('','');
      this.dataSource.data = [...this.dataSource.data, new CarVersion('','')];
      this.editingItemId = 0;
      this.editingItem = true;
      
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    
    //console.log(this.versions.find((manuf: CarVersion) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.versions.find((item: CarVersion) => item.id === id) );
    this.store.dispatch (CarRefActions.modelsFetchSubmit({ makeIds: [ this.editedItem.makeId ] }));
    console.log(this.editedItem);
  }

  saveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    console.log(this.editedItem);
    console.log(this.versions.find((manuf: CarVersion) => manuf.id === id));
    this.editedItem = Object.assign({}, this.versions.find((manuf: CarVersion) => manuf.id === id), this.editedItem);
    
    console.log(this.editedItem);
  
    if(id===0){
      this.store.dispatch (CarRefActions.versionNewSubmit({version: this.editedItem }));
    } else{
      this.editedItem.id=id;
      console.log(this.editedItem);
      this.store.dispatch (CarRefActions.versionUpdateSubmit({version: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(manuf => manuf.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.versionDeleteSubmit({versionId: id }));
    }
    
  }

  onMakeChange(){
    this.store.dispatch (CarRefActions.modelsFetchSubmit({makeIds: [this.editedItem.makeId] }));
    this.store.dispatch (CarRefActions.enginesFetchSubmit({}));
  }

 editedItemIsValid(): boolean{
  return this.editedItem.modelId > 0 && this.editedItem.makeId > 0 && this.editedItem.engines.length > 0 && this.editedItem.name.length > 0;
 }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}

